<template>
  <b-field :label="label">
    <div class="columns is-vcentered">
      <b-input
        v-model="montantMinInput"
        type="number"
        :disabled="disabled"
        class="column">
      </b-input>
      <span class="column is-1 has-text-centered">
        {{$t('general.a')}}
      </span>
      <b-input
        v-model="montantMaxInput"
        type="number"
        :disabled="disabled"
        class="column">
      </b-input>
    </div>
  </b-field>
</template>

<script>
export default {
  name: 'inputMontant',
  props: {
    value: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    montantMinInput: {
      get() {
        return this.value.montantMin !== null ? this.value.montantMin : '';
      },
      set(value) {
        const newValue = { ...this.value };
        newValue.montantMin = value === '' ? null : value;
        this.$emit('input', newValue);
      },
    },
    montantMaxInput: {
      get() {
        return this.value.montantMax !== null ? this.value.montantMax : '';
      },
      set(value) {
        const newValue = { ...this.value };
        newValue.montantMax = value === '' ? null : value;
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
